import { PaletteMode } from "@mui/material";
import { ThemeProvider as MUIThemeProvider } from "@mui/material";
import React from "react";

import { getTheme } from "./theme";

interface Props {
  children: React.ReactNode;
  paletteMode: PaletteMode;
}

const ThemeProvider: React.FC<Props> = ({ children, paletteMode }) => {
  return <MUIThemeProvider theme={getTheme(paletteMode)}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
